import { render } from "./AccountDetailsForm.vue?vue&type=template&id=5b219d51"
import script from "./AccountDetailsForm.vue?vue&type=script&lang=js"
export * from "./AccountDetailsForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__